import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, createContext, useMemo } from "react";
import { createDefaultStackOrderManager } from "./StackOrderManagerDefaultImpl";
/**
 * Used to keep track of the stack order of components subscribing to the context.
 *
 * This can be null because its consumers should be able to check whether or not there's a stack
 * around them. If there's no stack around them, floating elements shouldn't make assumptions
 * about stacking, in general.
 *
 * @see: useStackOrder
 */
export var StackOrderContext = /*#__PURE__*/createContext(null);
/**
 * ComponentsContainers rendered within a `StackOrderProvider`, allows closing coordination
 * among Components that subscribe to the behavior. The `StackOrderContextProvider` if not passed anything
 * will use a default implementation to manage the stackOrder, which should be sufficient for most cases (the exception being
 * coordinating across react instances, which would require a state-service or similar).
 */
export var StackOrderContextProvider = function StackOrderContextProvider(_ref) {
  var children = _ref.children,
    providedStackOrderManager = _ref.stackOrderManager;
  var _useState = useState(function () {
      return providedStackOrderManager || createDefaultStackOrderManager();
    }),
    _useState2 = _slicedToArray(_useState, 1),
    stackManager = _useState2[0];
  if (process.env.NODE_ENV !== "production") {
    if (providedStackOrderManager !== undefined && stackManager !== providedStackOrderManager) {
      throw new Error("The stackManager has changed. The manager should never change.");
    }
  }
  var contextValue = useMemo(function () {
    return {
      stackOrderManager: stackManager
    };
  }, [stackManager]);
  return /*#__PURE__*/React.createElement(StackOrderContext.Provider, {
    value: contextValue
  }, children);
};
//# sourceMappingURL=StackOrderContext.js.map